import { ReactNode, useRef } from 'react'
import { useMediaQuery, useResizeObserver } from 'usehooks-ts'

import styles from './SidePanelContainer.module.scss'

export type SidePanelProps = {
  children: ReactNode
}

export function SidePanelContainer({ children }: SidePanelProps) {
  const ref = useRef<HTMLDivElement>(null)
  const { height } = useResizeObserver({ ref })
  const screenMinHeight = 122 + (height ?? 0)
  const isHighScreen = useMediaQuery(`(min-height: ${screenMinHeight}px)`)

  return (
    <div className={styles.Wrapper}>
      {!isHighScreen && <div className={styles.Filler} style={{ height: `calc(100% - ${height ?? 800}px)` }} />}
      <div
        className={styles.StickyContainer}
        ref={ref}
        style={
          window.matchMedia(`(max-height: ${screenMinHeight}px)`).matches ? { bottom: 24, top: 'unset' } : undefined
        }
      >
        {children}
      </div>
    </div>
  )
}
